module.exports = __webpack_public_path__ + "theme/index/simpleblue/view/static/img/logo.e7a2d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 73